// src/components/BusinessExpensesTable.tsx
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  //TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TextField,
  Input,
    Paper, Button,
    TableFooter,
      Box
} from '@mui/material';
import styles from './BusinessExpensesTable.module.css';
import { BusinessExpenseCategories } from '../types/StockhornTypes';
import {Cookies}  from '../js/localStorageCode';
import {AddCommas} from './Utilities';
const environment = document.location.hostname.match(/meekmeek/) ? 'PROD' : document.location.hostname.match(/vercel/) ? 'PREVIEW': 'DEV';

const initialExpenses: BusinessExpenseCategories[] = [
  { id: 1, name: 'Accounting/Tax Prep', used: false, description: '', amount:0 },
  { id: 2, name: 'Advertising', used: false, description: '', amount:0 },
  { id: 3, name: 'Bank Charges', used: false, description: '', amount:0 },
  { id: 4, name: 'Business Gifts', used: false, description: '', amount:0 },
  { id: 5, name: 'Commissions', used: false, description: '', amount:0 },
  { id: 6, name: 'Credit/Collection', used: false, description: '', amount:0 },
  { id: 7, name: 'Computer Services/Supplies', used: false, description: '', amount:0 },
  { id: 8, name: 'Delivery/Freight', used: false, description: '', amount:0 },
  { id: 9, name: 'Discounts', used: false, description: '', amount:0 },
  { id: 10, name: 'Dues/Subscriptions', used: false, description: '', amount:0 },
  { id: 11, name: 'Equipment Rental', used: false, description: '', amount:0 },
  { id: 12, name: 'Insurance (other than health and medical)', used: false, description: '', amount:0 },
  { id: 13, name: 'Interest Expense', used: false, description: '', amount:0 },
  { id: 14, name: 'Janitorial', used: false, description: '', amount:0 },
  { id: 15, name: 'Laundry', used: false, description: '', amount:0 },
  { id: 16, name: 'Legal/Professional Fees', used: false, description: '', amount:0 },
  { id: 17, name: 'Office Expenses', used: false, description: '', amount:0 },
  { id: 18, name: 'Office Parking', used: false, description: '', amount:0 },
  { id: 19, name: 'Printing/Copying', used: false, description: '', amount:0 },
  { id: 20, name: 'Postage', used: false, description: '', amount:0 },
  { id: 21, name: 'Repairs/Maintenance', used: false, description: '', amount:0 },
  { id: 22, name: 'Security', used: false, description: '', amount:0 },
  { id: 23, name: 'Supplies', used: false, description: '', amount:0 },
  { id: 24, name: 'Telephone', used: false, description: '', amount:0 },
  { id: 25, name: 'Tools', used: false, description: '', amount:0 },
  { id: 26, name: 'Training/Education', used: false, description: '', amount:0 },
  { id: 27, name: 'Business Travel', used: false, description: '', amount:0 },
  { id: 28, name: 'Uniforms', used: false, description: '', amount:0 },
  { id: 29, name: 'Utilities', used: false, description: '', amount:0 },
  { id: 30, name: 'Taxes and Licenses', used: false, description: '', amount:0 },
  { id: 31, name: 'Local Property Taxes', used: false, description: '', amount:0 },
  { id: 32, name: 'Other Taxes', used: false, description: '', amount:0 },
  { id: 33, name: 'State Income Tax', used: false, description: '', amount:0 },
  { id: 34, name: 'Licenses, Permits, & Fees', used: false, description: '', amount:0 },
  { id: 35, name: 'Rent Expense', used: false, description: '', amount:0 },
  { id: 36, name: 'Office Equipment Rent', used: false, description: '', amount:0 },
  { id: 37, name: 'Renting Business Vehicles', used: false, description: '', amount:0 },
  { id: 38, name: 'Rental of office space', used: false, description: '', amount:0 },
  { id: 39, name: 'Meals and Entertainment', used: false, description: '', amount:0 },
  { id: 40, name: 'Company Party', used: false, description: '', amount:0 },
  { id: 41, name: 'Entertainment not for Employees', used: false, description: '', amount:0 },
  { id: 42, name: 'All other Meal and Entertainment', used: false, description: '', amount:0 },
  { id: 43, name: 'Auto and Truck Expense', used: false, description: '', amount:0 },
  { id: 44, name: 'Charitable Contributions', used: false, description: '', amount:0 },
  { id: 45, name: 'Investment Expense', used: false, description: '', amount:0 },
  { id: 46, name: 'All other Expenses', used: false, description: '', amount:0 },
  { id: 47, name: 'Other – Government Fee', used: false, description: '', amount:0 },
];

  document.title = environment+':Busniess Expenses';

const BusinessExpensesTable: React.FC = () => {
    const cookies = new Cookies();
  const [expenses, setExpenses] = useState<BusinessExpenseCategories[]>(() => {
    const saved = cookies.get("BusinessExpenses");
    //const saved = localStorage.getItem('businessExpenses');
    return saved ? JSON.parse(saved) : initialExpenses;
  });

  const handleCheckboxChange = (id: number) => {
    setExpenses((prev) =>
      prev.map((expense) =>
        expense.id === id ? { ...expense, used: !expense.used } : expense
      )
    );
  };

  const handleDescriptionChange = (id: number, description: string) => {
    setExpenses((prev) =>
      prev.map((expense) =>
        expense.id === id ? { ...expense, description } : expense
      )
    );
  };

    const handleAmountChange = (id: number, amount: number) => {
    setExpenses((prev) =>
      prev.map((expense) =>
        expense.id === id ? { ...expense, amount } : expense
      )
    );
  };

  const handleSave = (id: number) => {
    const expense = expenses.find((e) => e.id === id);
    if (expense) {
      //localStorage.setItem('businessExpenses', JSON.stringify(expenses));
      cookies.set("BusinessExpenses", JSON.stringify(expenses), {expires: 365});
      alert(`Saved: ${expense.name} (Used: ${expense.used}, Description: ${expense.description}, Amount: ${expense.amount})`);
    }
  };

    let totalAmount: number = 0;
    expenses.forEach(expense=> {
      totalAmount += (expense.amount? expense.amount : 0);
    });

  return (
            <Box className="MyTable" p={3}>
            <Paper elevation={0} sx={{ mb: 4, p: 0 }}>
      <Table className={styles.table} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell className={styles.expenseCell}>Expense</TableCell>
            <TableCell className={styles.checkboxCell}>Used</TableCell>
            <TableCell className={styles.descriptionCell}>Details/Description</TableCell>
            <TableCell className={styles.descriptionAmount}>Amount</TableCell>
            <TableCell className={styles.updateCell}>SAVE</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {expenses.map((expense) => (
            <TableRow key={expense.id}>
              <TableCell>{expense.name}</TableCell>
              <TableCell>
                <Checkbox
                  checked={expense.used}
                  onChange={() => handleCheckboxChange(expense.id)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={expense.description}
                  onChange={(e) => handleDescriptionChange(expense.id, e.target.value)}
                  className={styles.descriptionInput}
                  placeholder="Enter details"
                  fullWidth
                />
              </TableCell>
              <TableCell>
                <Input
                  type='float'
                  value={expense.amount}
                  onChange={(e) => handleAmountChange(expense.id, Number(e.target.value))}
                  className={styles.descriptionAmount}
                  placeholder="Enter amount"
                  fullWidth
                />
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleSave(expense.id)}
                >
                  Save
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
          <TableFooter>
           <TableRow className={styles.totalRow}>
            <TableCell colSpan={3}>Total</TableCell>
            <TableCell>${AddCommas(totalAmount)}</TableCell>
            <TableCell />
          </TableRow>
        </TableFooter>
      </Table>
    </Paper>
    </Box>
  );
};

export default BusinessExpensesTable;